<template>
<div
  class="row buttons-with-margin"
  v-loading="loading"
>
  <div class="col-md-12">
    <div class="card">
      <div class="card-content">
        <h3 class="card-title">Commands</h3>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <MigrateTicketsWinnersToWinnersDb class="command"/>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <remove-duplicated-files class="command"></remove-duplicated-files>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <remove-duplicated-lamps class="command"></remove-duplicated-lamps>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <remove-attachment-from-lamps class="command"></remove-attachment-from-lamps>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <copy-attachments class="command"></copy-attachments>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <set-eligible-true class="command"></set-eligible-true>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <set-winner-false class="command"></set-winner-false>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <generate-new-tickets class="command"></generate-new-tickets>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <set-eventid-lamps class="command"></set-eventid-lamps>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="command">
          <router-link :to="{name: 'commands.listAttachments', params: {connection: 'default'}}">
            <a class="btn btn-primary btn-fill btn-wd">Listar Attachments (trg_admin)</a>
          </router-link>
          <router-link :to="{name: 'commands.listAttachments', params: {connection: 'docs'}}">
            <a class="btn btn-primary btn-fill btn-wd">Listar Attachments (trg_docs)</a>
          </router-link>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <set-stock-null></set-stock-null>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <set-documented-at-null-delete-doc class="command"></set-documented-at-null-delete-doc>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <remove-docs-from-contemplados class="command"></remove-docs-from-contemplados>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <MigrateConfigurationsToNewDatabase class="command"></MigrateConfigurationsToNewDatabase>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <ChangeEventsTagNameToTagId class="command"></ChangeEventsTagNameToTagId>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <RemoveConfigurationsDuplicated class="command"></RemoveConfigurationsDuplicated>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <RemoveAllAboutAnEvent class="command"/>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <RemoveAllAboutAnEventWithoutCustomer class="command"/>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <MigrateEventsSpecificationsToNewDatabase class="command"/>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import AddEventIdOnLamps from 'src/commands/AddEventIdOnLamps.vue'
import CopyAttachments from 'src/commands/CopyAttachments.vue'
import GenerateNewTickets from 'src/commands/GenerateNewTickets.vue'
import RemoveAttachmentFromLamps from 'src/commands/RemoveAttachmentFromLamps.vue'
import RemoveDocsFromContemplados from 'src/commands/RemoveDocsFromContemplados.vue'
import RemoveDuplicatedFiles from 'src/commands/RemoveDuplicatedFiles'
import RemoveDuplicatedLamps from 'src/commands/RemoveDuplicatedLamps'
import SetDocumentedAtNullDeleteDoc from 'src/commands/SetDocumentedAtNullDeleteDoc.vue'
import SetEligibleTrue from 'src/commands/SetEligibleTrue.vue'
import SetEventidLamps from 'src/commands/SetEventidLamps.vue'
import SetStockNull from 'src/commands/SetStockNull.vue'
import SetWinnerFalse from 'src/commands/SetWinnerFalse.vue'
import MigrateConfigurationsToNewDatabase from 'src/commands/MigrateConfigurationsToNewDatabase.vue'
import ChangeEventsTagNameToTagId from 'src/commands/ChangeEventsTagNameToTagId.vue'
import RemoveConfigurationsDuplicated from 'src/commands/RemoveConfigurationsDuplicated.vue'
import RemoveAllAboutAnEvent from 'src/commands/RemoveAllAboutAnEvent.vue'
import RemoveAllAboutAnEventWithoutCustomer from 'src/commands/RemoveAllAboutAnEventWithoutCustomer.vue'
import MigrateEventsSpecificationsToNewDatabase from '../../commands/MigrateEventsSpecificationsToNewDatabase'
import MigrateTicketsWinnersToWinnersDb from '../../commands/MigrateTicketsWinnersToWinnersDb'

export default {
  components: {
    MigrateTicketsWinnersToWinnersDb,
    AddEventIdOnLamps,
    CopyAttachments,
    GenerateNewTickets,
    RemoveAttachmentFromLamps,
    RemoveDocsFromContemplados,
    RemoveDuplicatedFiles,
    RemoveDuplicatedLamps,
    SetDocumentedAtNullDeleteDoc,
    SetEligibleTrue,
    SetEventidLamps,
    SetStockNull,
    SetWinnerFalse,
    MigrateConfigurationsToNewDatabase,
    ChangeEventsTagNameToTagId,
    RemoveConfigurationsDuplicated,
    RemoveAllAboutAnEvent,
    RemoveAllAboutAnEventWithoutCustomer,
    MigrateEventsSpecificationsToNewDatabase
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions('events', ['fetchAll'])
  },
  mounted () {
    this.fetchAll({ trash: true, limit: 999999 })
  }
}
</script>
<style scoped>
  .command {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Commands/CommandsIndex.vue